// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Banco da Amazônia — COMPE 003 */
export const BancoDaAmazonia = createBankIcon({
  name: "Banco da Amazônia",
  slug: "bancodaamazonia",
  compe: "003",
  color: "#003c2d",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#003c2d;fill-opacity:1\"\n     id=\"bancodaamazonia_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(-5.0069,7.2881) scale(0.78523)\">\n    <path d=\"m44.959 70.107-11.819 16.627c30.216-29.63 66.359-9.4027 73.864-64.64-18.081 16.735-34.924 10.097-62.046 48.013\" style=\"fill:#00e12d\" />\n  </g>",
});
